// @flow

// Effect Manager
import { fork } from 'redux-saga/effects'

import controller from 'fc-ctrl-users'

// Sagas
import watchUserOperations from './operations'
import { watchOperations } from 'fc-operator-user'
import { watchOperations as watchBillingOperations } from 'hfty-operator-billing-info'


// Selectors
import operations$ from '../selectors/operations'
import billingInfoOperation$ from '../selectors/billingInfoOperation'

export default function *main (): Generator<*, void, *> {
  yield fork(controller.get, {
    url: '/hefty/client/',
    queryParams: {
      status: 'ACTIVE',
    },
  })
  yield fork(watchUserOperations)
  yield fork(watchBillingOperations, { billingInfoOperation$ })
  yield fork(watchOperations, { operations$ })
}
